import { render, staticRenderFns } from "./Instructions.vue?vue&type=template&id=ff762e86&scoped=true&"
import script from "./Instructions.vue?vue&type=script&lang=ts&"
export * from "./Instructions.vue?vue&type=script&lang=ts&"
import style0 from "./Instructions.vue?vue&type=style&index=0&id=ff762e86&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff762e86",
  null
  
)

export default component.exports